import axios from "axios";
import { API_URL } from "../../constants";

export const fetch = (companyId) => {
  const url = `${API_URL}/${companyId}/reservations`;
  return axios.get(url).then((response) => response.data);
};
